/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useDescriptionPanelStyles = makeStyles((theme: Theme) => ({
  panel: {
    maxWidth: '714px',
    padding: '20px 24px 24px 20px',
    borderRadius: '12px',
    backgroundColor: '#F6F7F8',
  },
  panelIconWrapper: {
    marginRight: '20px',
  },
  itemIcon: {
    width: '56px',
    height: '56px',
    overflow: 'hidden',
    borderRadius: '6px',
    '& img': {
      width: '100%',
      height: '100%',
    },
    '&> svg': {
      width: '56px',
      height: '56px',
    },
  },
  panelTitle: {
    color: theme.palette.primary.main,
    padding: 0,
    fontSize: '28px',
    lineHeight: ' 28px',
    fontWeight: 700,
    letterSpacing: '-0.5px',
  },
  panelEditWrapper: {
    display: 'inline-flex',
    paddingTop: '3px',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },
  lightBackground: {
    backgroundColor: '#ffffff !important',
  },
  disabled: {
    backgroundColor: '#BDC1C6',
    pointerEvents: 'none',
  },
}));
